var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-toast',{ref:"toast",staticClass:"network-error-toast",attrs:{"fixed":"","left":"2px","bottom":"2px","error":""}})}
var staticRenderFns = []

export { render, staticRenderFns }